import { createContext, useContext } from "react";

export type AssistantVariant = "default" | "inline" | "unified";

// Identifies which assistant is rendered, so shared pages/components can adapt per variant. `useContext` rather than
// React 19's `use`, as TimeZoneContext: `@workleap-ai/client` still declares a React 18 peer range.
export const AssistantVariantContext = createContext<AssistantVariant>("default");

export const useAssistantVariant = () => useContext(AssistantVariantContext);
